import { auth } from "../../../firebase";

export async function ensureFreshAuthToken() {
  if (auth.currentUser) {
    await auth.currentUser.getIdToken(true);
  }
}
